var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgDenied = function SvgDenied(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0C9 0 0 9 0 20C0 31 9 40 20 40C31 40 40 31 40 20C40 9 31 0 20 0ZM25 23C25.5714 23.5714 25.5714 24.4286 25 25C24.7143 25.2857 24.2857 25.4286 24 25.4286C23.7143 25.4286 23.2857 25.2857 23 25L20 22L17 25C16.7143 25.2857 16.2857 25.4286 16 25.4286C15.7143 25.4286 15.2857 25.2857 15 25C14.4286 24.4286 14.4286 23.5714 15 23L18 20L15 17C14.4286 16.4286 14.4286 15.5714 15 15C15.5714 14.4286 16.4286 14.4286 17 15L20 18L23 15C23.5714 14.4286 24.4286 14.4286 25 15C25.5714 15.5714 25.5714 16.4286 25 17L22 20L25 23Z",
    fill: "#FF3535"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgDenied);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/denied.f49668feda9a14bb855bd74d98b18c21.svg";